import { render, staticRenderFns } from "./ExportTab.vue?vue&type=template&id=277d904c&scoped=true&"
import script from "./ExportTab.vue?vue&type=script&lang=ts&"
export * from "./ExportTab.vue?vue&type=script&lang=ts&"
import style0 from "./ExportTab.vue?vue&type=style&index=0&id=277d904c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d904c",
  null
  
)

export default component.exports